import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeCreateSalesOrderFromCustomerOrder } from './serialize';

/**
 * 客訂建一張銷貨單（獨立 Transaction；結果永遠＝完整 DRAFT）。
 * POST `/crm/customer-order/{id}/sales-order`
 * Body：full DRAFT（見 `toCreateSalesOrderBody`）；`customerOrderLineId` 可選。
 *
 * @param {string} customerOrderId
 * @param {object} payload
 */
export async function createSalesOrderFromCustomerOrder(customerOrderId, payload) {
  const { data: raw } = await request.post(
    `/crm/customer-order/${customerOrderId}/sales-order`,
    serializeCreateSalesOrderFromCustomerOrder(payload),
  );
  return parseVer4DetailResponse(raw);
}
